export default "__VITE_ASSET__DF2sNk1W__"